import { LOCAL_STORAGE_USER_LOGIN_INFO } from '@app/constants/Common';

export const isVietnamese = (nationality) => {
  if (!nationality) return true; // Default to VN if blank
  const arr = String(nationality)
    .split(';')
    .map((item) => item.trim().toLowerCase());
  return arr.some((item) => item === 'vn' || item === 'người vn đang ở nn');
};

export const getCurrentUserName = () => {
  try {
    const raw = localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO);
    if (!raw) return '';
    const info = JSON.parse(raw);
    return info?.name || '';
  } catch (e) {
    return '';
  }
};

/**
 * Resolves "Gọi Person là" (callerName) and "User xưng là" (vocative) for a
 * candidate's email draft, per BosungDraftPreviewModal spec §Gọi Person là.
 */
export const resolvePersonalization = (personal = {}, location = {}) => {
  const isVN = isVietnamese(location.local_nationality);
  const gender = (personal.gender || '').toLowerCase().trim();

  if (!isVN) {
    let callerName = '';
    if (gender === 'nam') {
      callerName = 'Mr. ';
    } else if (gender === 'nữ' || gender === 'nu') {
      callerName = 'Ms. ';
    }
    return { callerName, vocative: '' };
  }

  const existingCaller = personal.caller_name_to_email || '';
  const existingVocative = personal.vocative || '';
  if (existingCaller || existingVocative) {
    return { callerName: existingCaller, vocative: existingVocative };
  }

  let callerName = '';
  if (gender === 'nam') {
    callerName = 'anh';
  } else if (gender === 'nữ' || gender === 'nu') {
    callerName = 'chị';
  }
  return { callerName, vocative: getCurrentUserName() };
};
